import { client } from "api";
import { OrderSerial } from "models/OrderSerial";

export type CreateOrderSerialRequest =
  // Required for creation
  { orderNo: string; rowNo: number } &
    // Optional for creation
    Partial<Pick<OrderSerial, "doa">> &
    // Exclude fields not needed for creation
    Omit<
      OrderSerial,
      | "id"
      | "rowNo"
      | "item"
      | "installed"
      | "room"
      | "roomClassification"
      | "children"
      | "editable"
      | "doaDate"
    >;

export type CreateOrderSerialResponse = OrderSerial;

export const createOrderSerial = ({ orderNo, ...data }: CreateOrderSerialRequest) =>
  client
    .post<CreateOrderSerialResponse>(`/order/create-new-serial/${orderNo}`, data)
    .then((res) => res.data);
